
import { mapState } from 'vuex';
import ReviewEditDialog from './components/ReviewEditDialog';

export default {
  i18nComponentKey: 'ReviewsEditLegacy.ReviewsEditLegacy',
  name: 'ReviewsEditLegacy',
  components: { ReviewEditDialog },
  data() {
    const { query, params } = this.$route;
    return {
      isLoading: true,
      isModeless: query.auto === '1',
      reviewId: params.review_id ? parseInt(params.review_id) : null
    };
  },
  computed: {
    ...mapState('window', ['windowService']),
    ...mapState('reviewSettings', ['reviewSettings']),
    password() {
      return this.$route.query.password;
    }
  },
  mounted() {
    this.$emit('ready');
    if (this.isModeless) {
      this.$nextTick(() => {
        const rect = this.$refs.dialog.$el.getBoundingClientRect();
        this.windowService.postMessage('init_popup', {
          direction: this.reviewSettings.popup_direction,
          offset_x: this.reviewSettings.popup_offset_x,
          offset_y: this.reviewSettings.popup_offset_y,
          width: rect.width,
          height: rect.height
        });
      });
    }
  },
  methods: {
    onClose() {
      if (this.isModeless) this.windowService.postMessage('set_close');
      else this.windowService.closeFullscreenPopup();
    },
    onSaved() {
      if (this.isModeless) this.windowService.postMessage('set_close');
      else this.windowService.closeFullscreenPopup('saved');
    }
  }
};
